export const getMyInvoisRequiredFields = key => {
    switch (key) {
        case 'profile':
            // sst_reg_no_source only required if company has SST turned on. This will be handled in the CompanyProfieRow and Company Profile index.js
            return ['legal_name', 'reg_no', 'reg_no_type', 'tax_id_no', 'msic_code'];
        case 'contact':
            return ['phone_no', 'phone_no_code'];
        case 'address':
            return ['street', 'city', 'state', 'country_code'];
        default:
            return [];
    }
};
